<template>
    <div>
        <div class="content">
            <h3>Información Básica</h3>
            <v-list>
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Sede</v-list-item-title>
                        <v-list-item-subtitle>{{ carreraSede.sede.sede }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Nombre de la carrera</v-list-item-title>
                        <v-list-item-subtitle>{{ carreraSede.alias }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Año</v-list-item-title>
                        <v-list-item-subtitle>{{ carreraSede.year }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Número de seguidores de carrera</v-list-item-title>
                        <v-list-item-subtitle>{{ carreraSede.likesCarrera }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Número de seguidores de universidad</v-list-item-title>
                        <v-list-item-subtitle>{{ carreraSede.likesCarrera }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <h3>Ponderaciones</h3>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th width="20%">Ponderable</th>
                            <th>Ponderación</th>
                            <th>Carrera genérica</th>
                            <th>Área</th>
                            <th width="20%">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="ponderacion in carreraSede.ponderaciones" :key="ponderacion.id">
                            <td>{{ ponderacion.ponderable.ponderable }}</td>
                            <td>{{ ponderacion.ponderacion }}</td>
                            <td>{{ carreraSede.carrera ? carreraSede.carrera.carrera : "" }}</td>
                            <td>{{ carreraSede.area }}</td>
                            <td>
                                <v-icon @click="deletePonderacion(ponderacion)">mdi-delete</v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-dialog v-model="ponderacionesDialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn @click="crearPonderacion" color="blue" v-on="on">Agregar ponderación</v-btn>
                </template>
                <models-ponderaciones-form
                    :carreraSedeId="carreraSede.id"
                    :creating="creatingPonderacion"
                    :ponderacion="ponderacionToEdit"
                    @created="onCreatedPonderacion($event)"
                ></models-ponderaciones-form>
            </v-dialog>

            <h3>Contenido Audiovisual</h3>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th width="20%">Tipo Audiovisual</th>
                            <th>Url</th>
                            <th width="20%">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="audiovisual in carreraSede.audiovisuales" :key="audiovisual.id">
                            <td>{{ audiovisual.tipoAudiovisual.tipoAudiovisual }}</td>
                            <td>{{ audiovisual.url }}</td>
                            <td>
                                <v-icon @click="editarAudiovisual(audiovisual)">mdi-pencil</v-icon>
                                <v-icon @click="deleteAudiovisual(audiovisual)">mdi-delete</v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-dialog v-model="audiovisualesDialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn @click="crearAudiovisual" color="blue" v-on="on">Agregar audiovisual</v-btn>
                </template>

                <models-audiovisuales-form
                    :carreraSedeId="carreraSede.id"
                    :creating="creatingAudiovisual"
                    :audiovisual="audiovisualToEdit"
                    @created="onCreatedAudiovisual($event)"
                    @updated="onUpdatedAudiovisual($event)"
                ></models-audiovisuales-form>
            </v-dialog>

            <h3>Informacion Adicional</h3>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th width="20%">Nombre</th>
                            <th>Es Link</th>
                            <th>Valor</th>
                            <th width="20%">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="infoAdicional in carreraSede.infoadicionales" :key="infoAdicional.id">
                            <td>{{ infoAdicional.infoAdicional }}</td>
                            <td>
                                <v-icon v-if="infoAdicional.isLink">mdi-check</v-icon>
                                <v-icon v-else>mdi-close</v-icon>
                            </td>
                            <td>
                                <a v-if="infoAdicional.isLink" :href="infoAdicional.valor" target="_blank">
                                    {{ infoAdicional.valor }}
                                </a>
                                <span v-else>{{ infoAdicional.valor }}</span>
                            </td>
                            <td>
                                <v-icon @click="editarInfoadicional(infoAdicional)">mdi-pencil</v-icon>
                                <v-icon @click="deleteInfoadicional(infoAdicional)">mdi-delete</v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-dialog v-model="infoadicionalesDialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn @click="crearInfoadicional" color="blue" v-on="on">Agregar Info Adicional</v-btn>
                </template>

                <models-infoadicionales-form
                    :carreraSedeId="carreraSede.id"
                    :creating="creatingInfoadicional"
                    :infoadicional="infoadicionalToEdit"
                    @created="onCreatedInfoadicional($event)"
                    @updated="onUpdatedInfoadicional($event)"
                ></models-infoadicionales-form>
            </v-dialog>

            <h3>Campos Extras</h3>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th width="20%">Título</th>
                            <th>Contenido</th>
                            <th width="20%">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="carreraSedeCampoExtra of carreraSede.carreraSedeCampoExtras"
                            :key="carreraSedeCampoExtra.id"
                        >
                            <td>{{ carreraSedeCampoExtra.campoExtra.campoExtra }}</td>
                            <td v-html="carreraSedeCampoExtra.campoExtra.contenido"></td>
                            <td>
                                <v-icon @click="editarCampoExtra(carreraSedeCampoExtra.campoExtra)">mdi-pencil</v-icon>
                                <v-icon @click="deleteCampoExtra(carreraSedeCampoExtra.campoExtra)">mdi-delete</v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-dialog v-model="campoExtraDialog" max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn @click="crearCampoExtra" color="blue" v-on="on">Agregar Campo Extra</v-btn>
                </template>

                <models-campo-extras-form
                    :carreraSedeId="carreraSede.id"
                    :campoExtraDialog="campoExtraDialog"
                    :creating="creatingCampoExtra"
                    :campoExtra="campoExtraToEdit"
                    @created="onCreatedCampoExtra($event)"
                    @updated="onUpdatedCampoExtra($event)"
                ></models-campo-extras-form>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import {
    PonderacionesService,
    AudiovisualesService,
    InfoAdicionalesService,
    CampoExtraService
} from "../../../services/carreras-api.service"
export default {
    data() {
        return {
            creatingPonderacion: false,
            ponderacionesDialog: false,
            ponderacionToEdit: null,

            creatingAudiovisual: false,
            audiovisualesDialog: false,
            audiovisualToEdit: null,

            creatingInfoadicional: false,
            infoadicionalesDialog: false,
            infoadicionalToEdit: null,

            creatingCampoExtra: false,
            campoExtraDialog: false,
            campoExtraToEdit: null
        }
    },
    props: ["carreraSede"],
    methods: {
        //ponderaciones
        crearPonderacion() {
            this.ponderacionToEdit = null
            this.creatingPonderacion = true
        },
        onCreatedPonderacion(element) {
            this.carreraSede.ponderaciones.push(element)
            this.ponderacionesDialog = false
        },
        deletePonderacion(ponderacion) {
            const index = this.carreraSede.ponderaciones.indexOf(ponderacion)
            PonderacionesService.destroy(ponderacion.id).then(() => {
                this.carreraSede.ponderaciones.splice(index, 1)
            })
        },

        //audiovisuales
        crearAudiovisual() {
            this.audiovisualToEdit = null
            this.creatingAudiovisual = true
        },
        editarAudiovisual(audiovisual) {
            this.audiovisualToEdit = audiovisual
            this.creatingAudiovisual = false
            this.audiovisualesDialog = true
        },
        onCreatedAudiovisual(audiovisual) {
            this.carreraSede.audiovisuales.push(audiovisual)
            this.audiovisualesDialog = false
        },
        onUpdatedAudiovisual(audiovisual) {
            const index = this.carreraSede.audiovisuales.indexOf(audiovisual)
            this.carreraSede.audiovisuales.splice(index, 1, audiovisual)
            this.audiovisualesDialog = false
        },
        deleteAudiovisual(audiovisual) {
            const index = this.carreraSede.audiovisuales.indexOf(audiovisual)
            AudiovisualesService.destroy(audiovisual.id).then(() => {
                this.carreraSede.audiovisuales.splice(index, 1)
            })
        },

        //infoadicionales
        crearInfoadicional() {
            this.infoadionalToEdit = null
            this.creatingInfoadicional = true
        },
        editarInfoadicional(infoadicional) {
            this.infoadicionalToEdit = infoadicional
            this.creatingInfoadicional = false
            this.infoadicionalesDialog = true
        },
        onCreatedInfoadicional(infoadicional) {
            this.carreraSede.infoadicionales.push(infoadicional)
            this.infoadicionalesDialog = false
        },
        onUpdatedInfoadicional(infoadicional) {
            const index = this.carreraSede.infoadicionales.indexOf(infoadicional)
            this.carreraSede.infoadicionales.splice(index, 1, infoadicional)
            this.infoadicionalesDialog = false
        },
        deleteInfoadicional(infoadicional) {
            const index = this.carreraSede.infoadicionales.indexOf(infoadicional)
            InfoAdicionalesService.destroy(infoadicional.id).then(() => {
                this.carreraSede.infoadicionales.splice(index, 1)
            })
        },

        //campo extras
        crearCampoExtra() {
            this.campoExtraToEdit = null
            this.creatingCampoExtra = true
        },

        editarCampoExtra(campoExtra) {
            this.campoExtraToEdit = campoExtra
            this.creatingCampoExtra = false
            this.campoExtraDialog = true
        },

        onCreatedCampoExtra(campoExtra) {
            this.carreraSede.carreraSedeCampoExtras.push({ campoExtra: campoExtra })
            this.campoExtraDialog = false
        },

        onUpdatedCampoExtra(campoExtra) {
            const index = this.carreraSede.carreraSedeCampoExtras.findIndex(csce => csce.campoExtra.id == campoExtra.id)
            this.carreraSede.carreraSedeCampoExtras.splice(index, 1, { campoExtra: campoExtra })

            this.campoExtraDialog = false
        },

        deleteCampoExtra(campoExtra) {
            const index = this.carreraSede.carreraSedeCampoExtras.findIndex(csce => csce.campoExtra.id == campoExtra.id)
            CampoExtraService.destroy(campoExtra.id).then(() => {
                this.carreraSede.carreraSedeCampoExtras.splice(index, 1)
            })
        }
    }
}
</script>

<style scoped>
.content {
    padding: 10px;
}
</style>
